import type { Control } from "react-hook-form";
import {
	Resources,
	useResource,
} from "web_myplann/Infrastructure/Translations/Resources";
import type {
	BuildingFormInput,
	BuildingFormOutput,
} from "web_myplann/Portfolio/Forms/BuildingShared/buildingFormSchema";
import { FlatRowFormInput } from "web_myplann/Shared/Components/FlatRow/FlatRowFormInput";

type Props = {
	control: Control<BuildingFormInput, unknown, BuildingFormOutput>;
};

const PropertyResources = Resources.PortfolioDetail.Property;
const FormResources = Resources.Portfolio.AddRealEstate;

export const BuildingIdentityFields = ({ control }: Props) => {
	const { t } = useResource();

	return (
		<>
			<FlatRowFormInput
				control={control}
				name="location"
				label={t(PropertyResources.StreetAndNumber)}
				placeholder={t(FormResources.Placeholders.fill)}
			/>
			<FlatRowFormInput
				control={control}
				name="locationMunicipality"
				label={t(PropertyResources.Municipality)}
				placeholder={t(FormResources.Placeholders.fill)}
			/>
			<FlatRowFormInput
				control={control}
				name="locationZipCode"
				label={t(PropertyResources.ZipCode)}
				placeholder={t(FormResources.Placeholders.fill)}
				inputMode="numeric"
			/>
		</>
	);
};
